import { Auth } from 'aws-amplify';
import axios from 'axios';

import constants from 'Services/constants';
import siteConfig from '~/config';

const telehealthAxiosConfig = {
  baseURL: siteConfig.TELEHEALTH_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
  timeout: constants.REQUEST_TIMEOUT,
};

const telehealthRequestDefault = {
  method: 'get',
};

const telehealthAxios = axios.create(telehealthAxiosConfig);

telehealthAxios.interceptors.request.use(
  (requestConfig) => new Promise((resolve, reject) => {
    Auth.currentSession()
      .then((data) => {
        if (data) {
          const { idToken: { jwtToken }} = data;
          resolve({
            ...requestConfig,
            headers: {
              ...requestConfig.headers,
              authorization: `Bearer ${jwtToken}`,
            },
          });
          return;
        }
        resolve(requestConfig);
      })
      .catch((error) => {
        if (error !== 'No current user') {
          reject(error);
        }
        resolve(requestConfig);
      });
  }),
  // Do something with request error
  (error) => Promise.reject(error)
);

telehealthAxios.interceptors.response.use(
  (response) => {
    // Do something with response data
    if (response && response.config && response.config.cancelTimeout) {
      window.clearTimeout(response.config.cancelTimeout);
    }
    if (response) {
      return response.data;
    }
    return Promise.reject(new Error(`Request failed with server response: ${response.data.msg}`));
  },
  (error) => {
    if (!axios.isCancel(error) && error.response) {
      if (error.config && error.config.cancelTimeout) {
        window.clearTimeout(error.config.cancelTimeout);
      }
    }
    return Promise.reject(error);
  }
);

const telehealthRequest = (config) => {
  const { CancelToken } = axios;
  const source = CancelToken.source();
  const cancelTimeout = window.setTimeout(() => {
    source.cancel(`Request took longer than the timeout of ${telehealthAxiosConfig.timeout}ms`);
  }, telehealthAxiosConfig.timeout);
  return telehealthAxios({
    cancelToken: source.token,
    cancelTimeout,
    ...telehealthRequestDefault,
    ...config,
  });
};

export default telehealthRequest;
